import styled from 'styled-components';

import { ActionButton } from 'components/action-button';

export const Container = styled.li`
  padding-block-start: 1rem;
  padding-block-end: 2rem;
  padding-inline: 2rem;
  text-align: center;
`;

export const Title = styled.h4`
  margin: 0;
  font-family: ${Styles.fontFamily.base};
`;

export const Body = styled.p`
  margin: 0;
`;

export const StyledButton = styled(ActionButton)`
  margin-block-start: 1.5rem;
  font-size: 1.125rem;
  width: 100%;
`;
